
import Layout from '../components/Layout';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Mail } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const positions = [
  {
    title: "Senior Frontend Developer",
    department: "Engineering",
    location: "Remote",
    type: "Full-time",
    description: "Join our core team and help build the next generation of Discord bots using React, TypeScript, and modern web technologies.",
    requirements: [
      "5+ years of experience with React",
      "Strong TypeScript skills",
      "Experience with modern frontend tooling",
      "Excellent problem-solving abilities"
    ],
    responsibilities: [
      "Lead frontend development initiatives",
      "Mentor junior developers",
      "Collaborate with design team",
      "Implement new features and improvements"
    ],
    benefits: [
      "Competitive salary",
      "Remote work flexibility",
      "Health insurance",
      "Learning budget"
    ]
  },
  {
    title: "AI Engineer",
    department: "AI/ML",
    location: "Remote",
    type: "Full-time",
    description: "Help develop and improve our AI capabilities, working with cutting-edge language models and machine learning technologies.",
    requirements: [
      "3+ years of experience in AI/ML",
      "Strong Python skills",
      "Experience with LLMs",
      "Background in NLP"
    ],
    responsibilities: [
      "Develop AI models and algorithms",
      "Optimize model performance",
      "Research new AI technologies",
      "Implement AI features"
    ],
    benefits: [
      "Competitive salary",
      "Remote work flexibility",
      "Health insurance",
      "Conference attendance"
    ]
  },
  {
    title: "Community Manager",
    department: "Operations",
    location: "Remote",
    type: "Full-time",
    description: "Lead our growing Discord community, organize events, and help shape our user engagement strategy.",
    requirements: [
      "3+ years community management experience",
      "Strong communication skills",
      "Experience with Discord",
      "Event planning experience"
    ],
    responsibilities: [
      "Manage Discord community",
      "Organize online events",
      "Create engagement strategies",
      "Handle user feedback"
    ],
    benefits: [
      "Competitive salary",
      "Remote work flexibility",
      "Health insurance",
      "Events budget"
    ]
  },
  {
    title: "Cuddlekitty",
    department: "Employee wellbeing",
    location: "In person",
    type: "Full-time",
    description: "Join our core team and help them overcome the process of build the next generation of Discord bots.",
    requirements: [
      "5+ years of experience with cuddling",
      "Nya nya™",
      "Experience with long cuddling sessions",
      "Excellent hugs and purring abilities"
    ],
    responsibilities: [
      "Provide daily cuddles to team members",
      "Boost morale and reduce stress",
      "Participate in team meetings as emotional support",
      "Ensure a positive and cozy work environment"
    ],
    benefits: [
      "Competitive salary",
      "On-site treats and toys",
      "Health insurance",
      "Nap breaks and cozy spaces"
    ]
  }
];

const OpenPositions = () => {
  return (
    <Layout>
      <div className="py-20">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 dark:text-white">
              Open Positions
            </h1>
            <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
              Join our team and help shape the future of Discord communities.
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <Accordion type="single" collapsible className="space-y-6">
              {positions.map((position, index) => (
                <AccordionItem key={index} value={`item-${index}`} className="border rounded-lg overflow-hidden">
                  <Card className="p-6">
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4">
                      <div>
                        <AccordionTrigger className="hover:no-underline">
                          <div className="text-left">
                            <h3 className="text-xl font-bold mb-2 dark:text-white">{position.title}</h3>
                            <div className="flex flex-wrap gap-2">
                              <Badge variant="secondary">{position.department}</Badge>
                              <Badge variant="outline">{position.location}</Badge>
                              <Badge>{position.type}</Badge>
                            </div>
                          </div>
                        </AccordionTrigger>
                      </div>
                      <Button 
                        onClick={() => window.location.href = `mailto:Fembot-HR<lunaxxdev@gmail.com>?subject=Application for ${position.title}`}
                        className="gradient-pink"
                      >
                        <Mail className="mr-2" />
                        Apply Now
                      </Button>
                    </div>
                    <AccordionContent>
                      <div className="space-y-6 pt-4">
                        <div>
                          <h4 className="font-semibold mb-2 text-lg">Description</h4>
                          <p className="text-gray-600 dark:text-gray-300">{position.description}</p>
                        </div>
                        
                        <div>
                          <h4 className="font-semibold mb-2 text-lg">Requirements</h4>
                          <ul className="list-disc pl-5 text-gray-600 dark:text-gray-300 space-y-1">
                            {position.requirements.map((req, i) => (
                              <li key={i}>{req}</li>
                            ))}
                          </ul>
                        </div>

                        <div>
                          <h4 className="font-semibold mb-2 text-lg">Responsibilities</h4>
                          <ul className="list-disc pl-5 text-gray-600 dark:text-gray-300 space-y-1">
                            {position.responsibilities.map((resp, i) => (
                              <li key={i}>{resp}</li>
                            ))}
                          </ul>
                        </div>

                        <div>
                          <h4 className="font-semibold mb-2 text-lg">Benefits</h4>
                          <ul className="list-disc pl-5 text-gray-600 dark:text-gray-300 space-y-1">
                            {position.benefits.map((benefit, i) => (
                              <li key={i}>{benefit}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </AccordionContent>
                  </Card>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default OpenPositions;
